import React, { useMemo } from 'react'
import * as icons from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'
import { Box, Typography } from '@material-ui/core'

type BadgeLevel = 'main' | 'dark' | 'light'
type BadgeType = 'error' | 'success' | 'info' | 'warning'

export type BadgeProps = {
  title: string,
  type: BadgeType,
  level: BadgeLevel,
  className?: string,
  description?: string,
  icon?: keyof typeof icons,
  hasError?: boolean
}

export const Badge: React.FC<BadgeProps> = (props) => {
  const { title, description, level, icon, type, hasError } = props

  const Icon = useMemo(() => icons[icon || 'BlockIcon'], [icon])

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        justifyContent: 'space-between',
        borderWidth: 1,
        borderStyle: 'solid',
        padding: 2,
        borderRadius: 1,
        borderColor: mutualTheme.palette.badgeBorderColor[type][level],
        backgroundColor: mutualTheme.palette.badgeBackgroundColor[type][level],
        marginTop: hasError ? 3 : 0
      }}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: mutualTheme.typography.body2.fontSize,
            color: mutualTheme.palette.badgeTitleText[type][level]
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: mutualTheme.typography.body2.fontSize,
            color: mutualTheme.palette.badgeDescriptionText[type][level]
          }}
        >
          {description}
        </Typography>
      </Box>
      {icon && <Icon htmlColor={mutualTheme.palette.badgeBackgroundColor[type].light} />}
    </Box>
  )
}
